module.exports = __webpack_public_path__ + "static/react-share-pin-example-da3d8140e097582c686c2b72bd80d582.png";